import styled from "@emotion/styled";
import { Card, CardContent, CardHeader, List, ListItem } from "@mui/material";
import { IWithClassName, IWithThemeProps } from "../../theme/default.theme";
import { DynamicMarkdownContent } from "../dynamic-markdown/dynamic-markdown-content";

interface IAnnouncementContainer {
    announcements?: Array<string>;
}

const AnnouncementContainer = ({
    announcements,
    className,
}: IAnnouncementContainer & IWithClassName) => (
    <>
        {announcements?.length ? (
            <Card className={className}>
                <CardHeader title="Announcements" />
                <CardContent>
                    <List>
                        <AnnouncementList announcements={announcements ?? []} />
                    </List>
                </CardContent>
            </Card>
        ) : null}
    </>
);

interface IAnnouncementList {
    announcements: Array<string>;
}

const AnnouncementList = ({ announcements }: IAnnouncementList) => (
    <>
        {announcements?.map((announcement) => (
            <ListItem key={announcement}>
                <DynamicMarkdownContent markdown={announcement} />
            </ListItem>
        ))}
    </>
);

export default styled(AnnouncementContainer)(({ theme }: IWithThemeProps) => ({
    padding: theme?.spacing(4),
    ".annoucement-node": {
        color: theme?.palette.announcement.primaryColor,
        fontSize: 22,
    },
    ".MuiCardHeader-root": {
        padding: theme?.spacing(1, 2),
    },
    ".MuiCardHeader-title": {
        fontWeight: 600,
        fontSize: 22,
    },
    ".MuiCardContent-root": {
        padding: theme?.spacing(1, 2),
    },
}));
